import React, { Component } from 'react';
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

export class ModalOk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show
        };
    }
    render() {
        return (
            <>
                <Modal show={this.props.show} onHide={this.props.onClick} backdrop="static" centered>
                    <Modal.Header>
                        <Modal.Title>{this.props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.props.message}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.props.onClickOk}>
                            Ok
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ModalOk;
